import { AccountType } from '@/data/usecases/account/account-type'
import { Account } from '@/domain/usecases'
import { FeatureFlag } from '@/infra/feature-flag/feature-flag'
import CompanyManagerBaseLoader from '@/main/routes/loaders/company-manager-base-loader'
import { LDClient } from 'launchdarkly-react-client-sdk'
import { QueryClient } from 'react-query'

export default class CompanyManagerDependentLicensesLoader extends CompanyManagerBaseLoader {
  constructor(
    readonly account: Account.Model,
    readonly queryClient: QueryClient,
    readonly ldClient: LDClient | undefined
  ) {
    super(account, undefined, queryClient, ldClient, FeatureFlag.Key.COMPANIES_ON_DEPENDENT_ROLLOUT)
  }

  async loader() {
    return this.defer({
      data: Promise.all([this.promiseAccountProfile()]).then(([licenses]) => ({
        licenses
      }))
    })
  }

  private async promiseAccountProfile() {
    return import('@remote/account/company-manager/remote-company-manager-plan-license-factory')
      .then(module => module.makeRemoteCompanyPlanLicense)
      .then(async makeRemotePlanLicense => {
        const remote = makeRemotePlanLicense(this.account.company.uniqueId, this.queryClient)
        return remote.loader()
      })
      .then(licenses =>
        licenses.filter(license => license.accountType === AccountType.Enum.DEPENDENT)
      )
  }
}
